module.exports = __webpack_public_path__ + "static/media/icon-toga.2b033bfb.svg";